/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useStoreLocator } from '@/data/Content/StoreLocator';
import { ContentContext } from '@/data/context/content';
import { StoreDetails } from '@/data/types/Store';
import { Marker } from '@react-google-maps/api';
import { FC, useContext } from 'react';

type StoreLocatorMarkerProps = {
	store: StoreDetails;
	index: number;
	clusterer?:any
};

export const StoreLocatorMarker: FC<StoreLocatorMarkerProps> = (props) => {
	const { store, index, clusterer  } = props;
	const { onMarkerClick, staticHostSecure } = useContext(ContentContext) as ReturnType<typeof useStoreLocator> & {staticHostSecure:string};

	return (
		<Marker
			icon={`${staticHostSecure}/wcsstore/IntertoysSAS/images/marker.png`}
			position={store.coordinates}
			onClick={(e) => onMarkerClick(e, index, store)}
			clusterer={clusterer}
		/>
	);
};
